import { useEffect } from 'react';
import { SidebarMode } from '@monorepo/base/src/components/sidebar/sidebar';
import { IControlledStore, useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useLocation } from 'react-router-dom';

interface IUseNestedSidebar {
	enterMode?: SidebarMode;
	leaveMode?: SidebarMode;
}

export function useNestedSidebar(props?: IUseNestedSidebar) {
	const { sidebarStore } = useStores<IControlledStore>();
	const { enterMode, leaveMode } = props || {};

	const location = useLocation();

	useEffect(() => {
		sidebarStore.setSidebarMode(enterMode || SidebarMode.HOVER);
		sidebarStore.setSidebarOpen(false);

		return () => {
			sidebarStore.setSidebarMode(leaveMode || SidebarMode.LOCK);
			sidebarStore.setSidebarOpen(true);
		};
	}, [location]);
}
